import React from "react";

import { FieldMapping } from "./constants";

export const Field = (props) => {
  const renderField = () => {
    const Component = FieldMapping[props.type];
    return <Component {...props} />;
  };

  return <div>{renderField()}</div>;
};
